module.exports = __webpack_public_path__ + "static/media/iv_down_green.b746b404.svg";